import _get from 'lodash.get';
// import { BET_HISTORY_MAX_REQUEST_LENGTH } from './betHistory.constants';
import { BET_HISTORY_MAX_REQUEST_LENGTH } from '../../BetHistory/components/betHistory.constants';
import ApiClient from '../../common/utils/apiClient';
import {
    formatBetHistoryBets,
    formatBetHistoryErrors,
} from '../../common/utils/formatBetHistory';

export const actionTypes = {
    CLEAR_BET_HISTORY: 'CLEAR_BET_HISTORY',
    BET_HISTORY_REQUESTED: 'BET_HISTORY_REQUESTED',
    BET_HISTORY_RECEIVED: 'BET_HISTORY_RECEIVED',
    BET_HISTORY_PAGE_CHANGE: 'BET_HISTORY_PAGE_CHANGE',
    TOGGLE_IS_SETTLED: 'TOGGLE_IS_SETTLED',
    SET_BET_HISTORY_ERROR: 'SET_BET_HISTORY_ERROR',
    SET_EXTERNAL_BET_HISTORY_URL: 'SET_EXTERNAL_BET_HISTORY_URL',
    SET_EXTERNAL_BET_HISTORY_ERROR: 'SET_EXTERNAL_BET_HISTORY_ERROR',
    CLEAR_EXTERNAL_BET_HISTORY_DATA: 'CLEAR_EXTERNAL_BET_HISTORY_DATA',
};

export const clearBetHistory = () => ({
    type: actionTypes.CLEAR_BET_HISTORY,
});

export const betHistoryPageChange = page => ({
    type: actionTypes.BET_HISTORY_PAGE_CHANGE,
    page,
});

const betHistoryRequested = params => ({
    type: actionTypes.BET_HISTORY_REQUESTED,
    params,
});

const betHistoryReceived = (betHistory, params) => ({
    type: actionTypes.BET_HISTORY_RECEIVED,
    betHistory,
    params,
});

const setBetHistoryError = (errorInfo, params) => ({
    type: actionTypes.SET_BET_HISTORY_ERROR,
    errorInfo,
    params,
});

export const getBetHistory = (bookmaker, isSettled) =>
    (dispatch) => {
        const params = { isSettled };

        const requestParams = {
            settled: isSettled ? 'y' : 'n',
            lastNumber: BET_HISTORY_MAX_REQUEST_LENGTH,
        };
        dispatch(betHistoryRequested(params));

        return ApiClient.getBetHistory(bookmaker, requestParams)
            .then((res) => {
                const bets = _get(res, 'data.data', []);
                const formatedBets = formatBetHistoryBets(bets);

                dispatch(betHistoryReceived(formatedBets, params));
                return formatedBets;
            })
            .catch((err) => {
                const errors = _get(err, 'response.data.errors', []);
                const formatedErrors = formatBetHistoryErrors(errors);

                dispatch(setBetHistoryError(formatedErrors, params));
                return Promise.reject(formatedErrors);
            });
    };

export const toggleIsSettled = () => ({
    type: actionTypes.TOGGLE_IS_SETTLED,
});

const setExternalBetHistoryUrl = externalBetHistoryUrl => ({
    type: actionTypes.SET_EXTERNAL_BET_HISTORY_URL,
    externalBetHistoryUrl,
});

const setIsExternalBetHistoryError = () => ({
    type: actionTypes.SET_EXTERNAL_BET_HISTORY_ERROR,
});

export const getExternalBetHistoryUrl = bookie => dispatch => (
    ApiClient.getExternalBetHistoryUrl(bookie)
        .then(response => (
            dispatch(
                setExternalBetHistoryUrl(
                    _get(response, 'data.meta.bookmaker_url', null),
                ),
            )
        ))
        .catch(() => (
            dispatch(setIsExternalBetHistoryError())
        ))
)

export const clearExternalBetHistoryData = () => ({
    type: actionTypes.CLEAR_EXTERNAL_BET_HISTORY_DATA,
});




// WEBPACK FOOTER //
// /src/js/bookmakersSwitcher/accountPage/accountPage.actions.js